import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { UiModule } from '../../ui/ui.module';
import { CoreModule } from '../../core/core.module';
import { EditLabelModalComponent } from './edit-label-modal/edit-label-modal.component';
import { OutletStoreArticlesPrintModalComponent } from './modals/outlet-store-articles-print-modal/outlet-store-articles-print-modal.component';
import { WhoPackedLabelPrintModalComponent } from './modals/who-packed-label-print-modal/who-packed-label-print-modal.component';
import { EtikettenPreviewModule } from '../etiketten/previews/etiketten-preview.module';

@NgModule({
  declarations: [
    EditLabelModalComponent,
    OutletStoreArticlesPrintModalComponent,
    WhoPackedLabelPrintModalComponent,
  ],
  exports: [
    EditLabelModalComponent,
    OutletStoreArticlesPrintModalComponent,
    WhoPackedLabelPrintModalComponent,
  ],
  imports: [
    CommonModule,
    UiModule,
    CoreModule,
    NzTabsModule,
    NzInputNumberModule,
    NzTooltipDirective,
    EtikettenPreviewModule,
  ]
})
export class LabelsSharedModule { }
